import { hydraUiApi } from '@/services/api';
import type { Campaign, Newsletter } from '@customerio/hydra-ui-api';
import type { SetupGuide } from '.';

export const getSetupGuide = async (environmentId: unknown) => {
  if (Number.isNaN(Number.parseFloat(environmentId as string))) {
    return null;
  }
  return await hydraUiApi.setupGuide.getCurrent({
    params: { path: { environment_id: String(environmentId) } },
  });
};

export const updateSetupGuide = async (environmentId: number, setupGuide: SetupGuide) => {
  await hydraUiApi.setupGuide.updateCurrent({
    params: { path: { environment_id: String(environmentId) } },
    body: { setup_guide: { ...setupGuide } },
  });
};

export const getFirstMessageData = async (
  environmentId: number,
  firstMessageId: number,
  firstMessageType: string,
): Promise<{ campaign?: Campaign; newsletter?: Newsletter }> => {
  if (firstMessageType === 'campaign') {
    const data = await hydraUiApi.campaigns.get({
      params: { path: { environment_id: String(environmentId), campaign_id: String(firstMessageId) } },
    });
    return { campaign: data.campaign };
  }
  const data = await hydraUiApi.newsletters.get({
    params: { path: { environment_id: String(environmentId), id: String(firstMessageId) } },
  });
  return { newsletter: data.newsletter };
};
